import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { Button, Col, Row } from 'antd';

const FieldArrayInput = ({ name, renderInput, fieldToAdd, allowFirstInput = false }) => {
    const { values } = useFormikContext();
    return (
        <FieldArray name={name}>
            {arrayHelpers => (
                <div>
                    {values[name].map((_, index) => (
                        <Row
                            gutter={[5, 6]}
                            key={index}
                        >
                            <Col xs={24} md={24} lg={18} >
                                {renderInput(index)}
                            </Col>
                            <Col xs={24} md={24} lg={6}>
                                <Button
                                    disabled={allowFirstInput && values[name].length === 1}
                                    type="primary"
                                    danger onClick={() => arrayHelpers.remove(index)}
                                >
                                    -
                                </Button></Col>
                        </Row>
                    ))}
                    <Button
                        type="primary"
                        style={{ width: "100%", marginTop: 5 }}
                        onClick={() => arrayHelpers.push(fieldToAdd)}
                        disabled={values[name] === 4}
                    >
                        +
                    </Button>
                </div>
            )}
        </FieldArray>
    );
};

export default FieldArrayInput;
